var to = require('await-to-js').default
var storage = require('../firebaseStorage.js')

async function upload(  params) {
    console.log(params)
    let error, result;
    [error, result]  = await to(storage.uploadToStorage( params))
  
    if (error){
        console.error("storage error", error)

        throw error
        //propogate error to higher level
    }
    console.log("storage result", result)
    return result
  
}

async function download(  params) {
    console.log(params)
    let error, result;
    [error, result]  = await to(storage.downloadFromStorage( params))
  
    if (error){
        console.error("storage error", error)

        throw error
        //propogate error to higher level
    }
    console.log("storage result", result)
    return result
  
}

async function deleteFile(  params) {
    console.log(params)
    let error, result;
    [error, result]  = await to(storage.deleteFileFromStorage( params))
  
    if (error){
        console.error("storage error", error)

        throw error
        //propogate error to higher level
    }
    console.log("storage result", result)
    return result
  
}

module.exports = {upload, download, deleteFile}


// WEBPACK FOOTER //
// ./src/services/Storage/storage.js